import { useEffect } from "react";
import { useCart } from "../cart/CartContext";
import StoreHeader from "../components/StoreHeader";

export default function OrderConfirmedPage({ storeSlug }) {
  const { clearCart } = useCart();
  const orderId = new URLSearchParams(window.location.search).get("orderId");

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  return (
    <div className="storefront-shell">
      <StoreHeader storeName="Pedido confirmado" storeSlug={storeSlug} />
      <main className="order-confirmed">
        <div className="order-confirmed__mark">✓</div>
        <p className="eyebrow">Pagamento aprovado</p>
        <h1>Seu pedido foi confirmado</h1>
        <p>
          Enviamos os detalhes da compra para o seu e-mail.
          {orderId ? ` Pedido ${orderId}.` : ""}
        </p>
        <a href={`/commerce/${encodeURIComponent(storeSlug)}`}>
          Continuar comprando
        </a>
      </main>
    </div>
  );
}
